// API URL helper - uses relative paths so it works on ANY domain
// On preview: /api/bookings -> https://velaro-concierge.preview.emergentagent.com/api/bookings
// On production: /api/bookings -> https://www.velarotransfer.com/api/bookings
const getApiUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  // If env URL is set and we're on the same domain, use it
  // Otherwise use relative path (empty string) so it works on any domain
  if (envUrl) {
    try {
      const envHost = new URL(envUrl).hostname;
      const currentHost = window.location.hostname;
      if (envHost === currentHost) {
        return envUrl;
      }
    } catch (e) {
      // Invalid URL, fall through to relative
    }
  }
  // Use relative path - works on ALL domains via ingress routing
  return '';
};

export const API_URL = getApiUrl();
